///
/// EarthBrowser
///
/// Created by Matt Giger on 9/21/2026
/// Copyright (c) 2026 Geodata Labs
///
/// The engine's seam to user-facing notifications (React toasts). Engine
/// code (dataset layers, DatasetLayerManager) notifies through this module
/// instead of importing components, so builds without React (the /embed
/// globe-only entry) tree-shake the component graph away.
///
/// The default implementation is inert. The app bootstrap installs the
/// toast-backed implementation (redux/engineBridgeSetup.ts) alongside the
/// redux engine bridge; the embed never installs one.
///

import type { AlertSeverity } from "@/earthbrowser/dataset-distribution/alerts/AlertsTable"

export interface WeatherAlertNotification {
	/** Alert id (weather_alerts table primary key, used by selectId) */
	id: string
	/** Display label, e.g. "Tornado Warning · Carson, TX" */
	label: string
	severity: AlertSeverity
}

export interface StormAdvisoryNotification {
	/** Storm id (hurricanes table primary key, used by selectId) */
	id: string
	/** Display label, e.g. "Hurricane Melissa · Advisory 12" */
	label: string
}

export interface EngineNotifier {
	/** Generic toast (title/description/duration) */
	toast(options: { title: string; description?: string; duration?: number }): void
	/** New Extreme/Severe weather alerts landed in a dataset sync */
	weatherAlerts(updates: WeatherAlertNotification[]): void
	/** New storm advisories landed in a dataset sync */
	stormAdvisories(updates: StormAdvisoryNotification[]): void
}

const inertNotifier: EngineNotifier = {
	toast: () => {},
	weatherAlerts: () => {},
	stormAdvisories: () => {},
}

export let engineNotifier: EngineNotifier = inertNotifier

export function installEngineNotifier(notifier: EngineNotifier): void {
	engineNotifier = notifier
}
